import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  getScenario,
  getScenarioQueryKey,
  type ScenarioDetail,
} from '../api/automations.client.js';

export function useScenario(scenarioId: string | null) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useQuery<ScenarioDetail, Error>({
    queryKey: getScenarioQueryKey(workspaceId, scenarioId ?? 'none'),
    queryFn: () => {
      if (scenarioId === null) throw new Error('no scenarioId');
      return getScenario(scenarioId);
    },
    enabled: scope !== null && scenarioId !== null,
  });
}
